var mode = "npr";
if (document.querySelector("body").classList.contains("khn")) {
  mode = "khn";
}
switch(mode) {
  case "khn":
    require("./khn/webfonts_khn.js");
    break;
  default:
    require("./lib/webfonts");
    break;
}

var pym = require("./lib/pym");
var { isMobile } = require("./lib/breakpoints");

var onWindowLoaded = function() {
  pym.then(child => {
    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
}

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);